interface FormatAttributeName {
  (name: unknown): string;
}

export const formatAttributeName: FormatAttributeName = (name) => {
  if (typeof name !== "string") {
    console.warn("Invalid attribute name:", name);
    return "Unknown";
  }
  // Capitalize the first letter of each word
  return name
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
